module.exports = __webpack_public_path__ + "a45231d40c5e618f02372f1b161734d4.svg";